
<template>
  <Modal
    v-model="showModal"
    class-name="vertical-center-modal"
    footer-hide>
    <LoginForm v-if="showModal"/>
  </Modal>
</template>

<script>
import LoginForm from './LoginForm'

export default {
  components: {
    LoginForm
  },

  data () {
    return {
      showModal: false
    }
  },

  methods: {
    openModal () {
      this.showModal = true
    }
  }
}
</script>

<style lang="scss">
  .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal{
      top: 0;
    }
  }
</style>
